import { useRequestParams } from "contexts/RequestParamsProvider";
import DatePicker from "react-datepicker";
import { useState } from "react";
import { Flex, Text } from "@chakra-ui/react";
import { DocumentsFilter, FilterActionButtons } from "../DocumentsFilter";
import { localToUTCDate, utcToLocalDate } from "util/time";
import { GenericFilterProps } from "./generic-filter-props";
import { formatDate } from "util/statHelpers";

const DateRangePickerAndActionButtons = ({
  filterKey,
  startDateFilter,
  endDateFilter,
}: {
  filterKey: string;
  startDateFilter?: Date;
  endDateFilter?: Date;
}) => {
  const { onChangeDateRange } = useRequestParams();

  const [startDate, setStartDate] = useState(startDateFilter);
  const [endDate, setEndDate] = useState(endDateFilter);
  const onChange = ([start, end]: [Date | null, Date | null]) => {
    setStartDate(localToUTCDate(start ?? undefined));
    setEndDate(localToUTCDate(end ?? undefined));
  };

  const onSet = () => {
    onChangeDateRange(filterKey, startDate, endDate);
  };

  const onReset = () => {
    setStartDate(undefined);
    setEndDate(undefined);
    onChangeDateRange(filterKey, undefined, undefined);
  };

  return (
    <>
      <Flex px={6} justifyContent="center">
        <DatePicker
          onChange={onChange}
          selected={utcToLocalDate(startDate)}
          startDate={utcToLocalDate(startDate)}
          endDate={utcToLocalDate(endDate)}
          minDate={new Date(2019, 6, 1)}
          selectsRange
          inline
        />
      </Flex>
      <Text textAlign="center" textStyle="body2" px={16} py={2}>
        {startDate && formatDate(startDate)} - {endDate && formatDate(endDate)}
      </Text>

      <FilterActionButtons
        onReset={onReset}
        isResetDisabled={!startDate && !endDate}
        onSet={onSet}
        isSetDisabled={
          startDate === startDateFilter && endDate === endDateFilter
        }
      />
    </>
  );
};

export const DateRangeFilter = ({
  filterKey,
  variant,
  name,
}: GenericFilterProps) => {
  const { filters } = useRequestParams();
  const startDateFilter = filters[`${filterKey}StartDate`] as Date | undefined;
  const endDateFilter = filters[`${filterKey}EndDate`] as Date | undefined;

  return (
    <DocumentsFilter
      name={name}
      isSet={!!startDateFilter || !!endDateFilter}
      variant={variant}
    >
      <DateRangePickerAndActionButtons
        {...{ startDateFilter, endDateFilter, filterKey }}
      />
    </DocumentsFilter>
  );
};
